export const cropMsg = (msg: string, lengthLimit = 200) => {
  return msg.length > lengthLimit ? msg.slice(0, lengthLimit) + '...' : msg;
};
